/*  Copyright (C) 2021 OhmConnect, Inc. - All Rights Reserved  */
import React from 'react';

export default function MegaphoneLine({className}) {
  return (
    <svg
      {...{className}}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.25 7.5V19.0986C14.25 19.2221 14.2805 19.3436 14.3387 19.4525C14.397 19.5614 14.4812 19.6542 14.584 19.7226L15.6145 20.4097C15.7145 20.4763 15.829 20.518 15.9485 20.5311C16.068 20.5443 16.1889 20.5285 16.301 20.4852C16.4131 20.4418 16.5131 20.3722 16.5927 20.2821C16.6722 20.192 16.729 20.0841 16.7581 19.9675L18 15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 15.0001C18.9946 15.0001 19.9484 14.605 20.6517 13.9018C21.3549 13.1985 21.75 12.2447 21.75 11.2501C21.75 10.2555 21.3549 9.30172 20.6517 8.59846C19.9484 7.89519 18.9946 7.50011 18 7.50011H14.25C14.25 7.50011 9.14515 7.50011 4.23271 3.38002C4.12346 3.28806 3.99022 3.22921 3.84866 3.2104C3.70711 3.19158 3.56312 3.21357 3.43364 3.27379C3.30416 3.33401 3.19456 3.42995 3.11774 3.55033C3.04092 3.67071 3.00007 3.81052 3 3.95332V18.5469C3.00007 18.6897 3.04092 18.8295 3.11774 18.9499C3.19456 19.0703 3.30416 19.1662 3.43364 19.2264C3.56312 19.2866 3.70711 19.3086 3.84866 19.2898C3.99022 19.271 4.12346 19.2122 4.23271 19.1202C9.14515 15.0001 14.25 15.0001 14.25 15.0001H18Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
